import ShareImage from '../assets/images/share.png';
import BuildYourBoligmappaImage from '../assets/images/13@2x.png';
import RequestImage from '../assets/images/MissingDocuments@2x.png';
import RegisterImage from '../assets/images/UploadDocuments@2x.png';
import PublicShareImage from '../assets/images/SharewithSurveyor@2x.png';
import FindProfesionalsImage from '../assets/images/findprofessionals@2x.png';

export const features = [
  {
    code: 'MISSING_DOCUMENTS',
    privatePropertyOnly: false,
    renderTitle: ({ isDesktop }) =>
      isDesktop ? 'Mangler du dokumentasjon?' : 'Mangler du noe?',
    image: RequestImage,
    buttonLink: 'create-mdr',
    buttonText: 'Etterspør',
    description:
      'Dokumentasjon fra håndverkeren er et verdipapir. Vi hjelper deg å få tak i den.',
    descriptionMobile:
      'Dokumentasjon fra håndverkeren er et verdipapir. Vi hjelper deg å få tak i den.',
    gaEventTxt: 'Missing / Request Documentation',
  },
  {
    code: 'UPLOAD_DOCUMENTS',
    privatePropertyOnly: false,
    title: 'Last opp boligens verdipapirer',
    image: RegisterImage,
    buttonLink: '',
    buttonText: 'Last opp',
    description:
      'Våtromssertifikat og kontroll av elektrisk anlegg er eksempler på dokumentasjon som bør lastes opp.',
    descriptionMobile:
      'Våtromssertifikat og kontroll av elektrisk anlegg er eksempler på dokumentasjon som bør lastes opp.',
    gaEventTxt: 'Upload Documents',
  },
  {
    code: 'SURVEYOR_SHARE',
    privatePropertyOnly: true,
    title: 'Del mappa med takstmann',
    image: PublicShareImage,
    buttonLink: 'more/share',
    buttonText: 'Del',
    description:
      'Har takstmann bedt om innsyn? Her kan du enkelt dele boligens tilstand med takstmann.',
    descriptionMobile:
      'Har takstmann bedt om innsyn? Her kan du enkelt dele boligens tilstand med takstmann.',
    gaEventTxt: 'Share with surveyor',
  },
  {
    code: 'BUILD_YOUR_BOLIGMAPPA',
    privatePropertyOnly: false,
    title: 'Bygg mappa di',
    image: BuildYourBoligmappaImage,
    buttonLink: 'home',
    buttonText: 'Bygg mappa di',
    description:
      'Vi har laget en flyt som hjelper deg med å legge inn det viktigste av informasjon i din boligmappe. På 1-2-3 så har du opprettet en romstruktur, de viktigste hendelsen for eiendommen – og ikke minst bilder og dokumentasjon på hva som er blitt gjort.',
    descriptionMobile:
      'Vi har laget en flyt som hjelper deg med å legge inn det viktigste av informasjon i din boligmappe.',
    gaEventTxt: 'Build your boligmappa',
  },
  {
    code: 'PRIVATE_SHARE',
    privatePropertyOnly: true,
    title: 'Del offentlig',
    image: ShareImage,
    buttonLink: 'more/private-share',
    buttonText: 'Del',
    description:
      'La interessenter få innsyn i din boligmappe, for eksempel boligkjøpere som ønsker å sjekke ut boligens tilstand.',
    descriptionMobile:
      'La interessenter få innsyn i din boligmappe, for eksempel boligkjøpere som ønsker å sjekke ut boligens tilstand.',
    gaEventTxt: 'Private Sharing',
  },
  {
    code: 'FIND_PROFESSIONALS',
    privatePropertyOnly: false,
    title: 'Finn håndverker',
    image: FindProfesionalsImage,
    buttonLink: 'more/find-professional',
    buttonText: 'Finn håndverker',
    description:
      'Alle bedrifter som bruker  Boligmappa er kontrollert for fagkompetanse, økonomi og selskapsform.',
    descriptionMobile:
      'Alle bedrifter er kontrollert for fagkompetanse, økonomi og selskapsform.',
    gaEventTxt: 'Register Work / New Event',
  },
];
